import React, { useEffect } from "react";
import { sanitizeNoticeHtml } from "../../utils/noticeModal";
import "./styles.css";

export default function NoticeModal({ config, onClose }) {
  const button = config && config.button ? config.button : {};
  const isDismissible = !config || config.dismissible !== false;
  const title = sanitizeNoticeHtml(config ? config.title : "");
  const content = sanitizeNoticeHtml(config ? config.content : "");
  const target = button.target || "_blank";
  const rel = target === "_blank" ? "noopener noreferrer" : undefined;

  useEffect(() => {
    if (!config) {
      return undefined;
    }

    document.documentElement.classList.add("notice-modal-open");
    document.body.classList.add("notice-modal-open");

    return () => {
      document.documentElement.classList.remove("notice-modal-open");
      document.body.classList.remove("notice-modal-open");
    };
  }, [config]);

  if (!config) {
    return null;
  }

  return (
    <div
      className="noticeModal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="notice-modal-title"
      onClick={isDismissible ? onClose : undefined}
    >
      <section
        className="noticeModal__card"
        onClick={(event) => event.stopPropagation()}
      >
        {isDismissible ? (
          <button
            type="button"
            className="noticeModal__close"
            onClick={onClose}
            title="Fechar"
            aria-label="Fechar aviso"
          >
            Fechar
          </button>
        ) : null}
        <h2
          id="notice-modal-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div
          className="noticeModal__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <a
          className="noticeModal__action"
          href={button.url}
          target={target}
          rel={rel}
          title={button.label}
        >
          {button.label}
        </a>
      </section>
    </div>
  );
}
